import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/buildingLevel2/importer/buildingLevel2ImporterActions';

export default importerReducers(actions);
